module.exports = __webpack_public_path__ + "img/home_connect.568dce97.png";